
<ng-container role="main" class="registration col-xs-12 no-padding margin-B20">
  @if (showloader) {
    <div class="loading" >
      <div class="loading_txt">
        <div class="load_txt">Loading</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }

  <!-- <section class="col-xs-12 col-md-12 newresgistrationtitle">
  <div class="col-xs-12 col-md-8">
    <div class="newreg_header">Create a Seqirus Business Account</div>
  </div>
  <div class="col-xs-12 regcart_dateheader">
    <div class="regcaption_1">flu360  |  Support</div>
    <div class="regcaption_email">Email: <a href="mailto:flu.salesuk@seqirus.com" class="showPopupclick removeEmailleave">flu.salesuk&#64;seqirus.com</a></div>
    <div class="regcaption_email">Call: <a href="tel:03450093804" class="showPopupclick removephoneleave">0345 009 3804</a>&nbsp;(8:30 - 17:00)</div>
  </div>
</section> -->
<!--login left navigation For Login -->
<section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding log_Reg_Navigatesection">
  <div class="col-md-3 Loginregistration_nagivationPart leftelement" id="Loginregistration_nagivationPart1" [ngClass]="{'active': getActiveSection() === 'business', 'inactive': getActiveSection() !== 'business'}">
    <div class="Loginregistration_nagivationNo">
      <!-- <div class="Loginregistration_nagivationNumeric" [ngStyle]="{'display': getActiveSection() === 'business' ? 'block' : 'none'}">1</div>
      <div class="registration_nagivationtick" [ngStyle]="{'display':isContactsActive() || getActiveSection() === 'review' ? 'block' : 'none'}"><img src="assets/images/greentick.png" alt=""></div> -->
      <div class="Loginregistration_nagivationNumeric">1</div>
    </div>
    <div class="Loginregistration_nagivationName">{{'progresslabel.businessDetails' | cxTranslate}}</div>
  </div>
  <div class="col-md-3 Loginregistration_nagivationPart" [ngClass]="{'active': isContactsActive(), 'inactive': !isContactsActive()}" id="Loginregistration_nagivationPart2">
    <div class="Loginregistration_nagivationNo">
      <!-- <div class="Loginregistration_nagivationNumeric" [ngStyle]="{'display': (isContactsActive() && getActiveSection() !== 'review') || getActiveSection() === 'business' ? 'block' : 'none'}">2</div>
      <div class="registration_nagivationtick" [ngStyle]="{'display': getActiveSection() === 'review' ? 'block' : 'none'}"><img src="assets/images/greentick.png" alt=""></div> -->      
      <div class="Loginregistration_nagivationNumeric">2</div>
    </div>
    <div class="Loginregistration_nagivationName">{{'progresslabel.contactAddress' | cxTranslate}}</div>
  </div>
  <div class="col-md-3 Loginregistration_nagivationPart" id="Loginregistration_nagivationPart3" [ngClass]="{'active': getActiveSection() === 'review', 'inactive': getActiveSection() !== 'review'}">
    <div class="Loginregistration_nagivationNo">
      <!-- <div class="Loginregistration_nagivationNumeric" [ngStyle]="{'display': (isContactsActive() && getActiveSection() !== 'review') || getActiveSection() === 'business' ? 'block' : 'none'}">2</div>
      <div class="registration_nagivationtick" [ngStyle]="{'display': getActiveSection() === 'review' ? 'block' : 'none'}"><img src="assets/images/greentick.png" alt=""></div> -->
      <div class="Loginregistration_nagivationNumeric">3</div>
    </div>
    <div class="Loginregistration_nagivationName">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
  </div>
  <div class="col-md-3 Loginregistration_help">
    <div class="registration_help loginhelp">
      {{'bussinessDetails.Havingtrouble' | cxTranslate}}
      &nbsp;
      <a  [routerLink]="'/help-and-faq'" target="_blank" class="showPopupclick">
        <span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span>
        <div class="global_blackarrow"></div>
      </a>
    </div>
  </div>
</section>
@if (isContactsActive()) {
  <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12  contactsubsection"   [ngClass]="{'active': isContactsActive(), 'inactive': !isContactsActive()}">
    <div class="col-md-4 contactsubtxt"  [ngClass]="{'activestate': getActiveSection() === 'invoice', 'inactive': getActiveSection() !== 'invoice'}" id="logininvoice"><span class="activedot"></span>{{'progresslabel.invoiceinformation' | cxTranslate}}</div>
    <div class="col-md-4 contactsubtxt" [ngClass]="{'activestate': getActiveSection() === 'paying', 'inactive': getActiveSection() !== 'paying'}" id="loginpaying"><span class="activedot"></span>{{'progresslabel.payerinformation' | cxTranslate}}</div>
    <div class="col-md-4 contactsubtxt" [ngClass]="{'activestate': getActiveSection() === 'shipping', 'inactive': getActiveSection() !== 'shipping'}" id="logindeliveryloc"><span class="activedot"></span>{{'progresslabel.deliverylocation' | cxTranslate}}</div>
  </section>
}

<!--login left navigation For Not Login-->
<div class="col-lg-3 col-md-4 col-sm-12 col-xs-12 registration_leftside no-padding-right">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_nagivation no-padding">
    <div class="registration_nagivationPart" id="registration_nagivationPart1" >
      <div class="registration_nagivationNo">
        <!-- <div class="registration_nagivationtick reg_Navigationtick"><img src="assets/images/greentick.png" alt=""></div> -->
        <div class="registration_nagivationNumeric">1</div>
      </div>
      <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
    </div>
    <div class="registration_nagivationPart" [ngClass]="{'currentsection': getActiveSection() === 'business'}">
      <div class="registration_nagivationNo">
        <!-- <div class="registration_nagivationNumeric" [ngStyle]="{'display': getActiveSection() === 'business' ? 'block' : 'none'}">2</div>
        <div class="registration_nagivationtick" [ngStyle]="{'display':isContactsActive() || getActiveSection() === 'review' ? 'block' : 'none'}"><img src="assets/images/greentick.png" alt=""></div> -->
        <div class="registration_nagivationNumeric">2</div>
      </div>
      <div class="registration_nagivationName" id="registration_nagivationPart2" [ngClass]="{'active': getActiveSection() === 'business', 'inactive': getActiveSection() !== 'business'}">{{'progresslabel.businessDetails' | cxTranslate}}</div>
    </div>
    <div class="registration_nagivationPart" id="registration_nagivationPart3" [ngClass]="{'currentsection': isContactsActive()}">
      <div class="registration_nagivationNo">
        <!-- <div class="registration_nagivationNumeric" [ngStyle]="{'display': ((isContactsActive() && getActiveSection() !== 'review') || getActiveSection() === 'business') ? 'block' : 'none'}">3</div>
        <div class="registration_nagivationtick" [ngStyle]="{'display': getActiveSection() === 'review' ? 'block' : 'none'}"><img src="assets/images/greentick.png" alt=""></div> -->
        <div class="registration_nagivationNumeric">3</div>
      </div>
      <div class="registration_nagivationName"  [ngClass]="{'active': isContactsActive(), 'inactive': !isContactsActive()}">{{'progresslabel.contactAddress' | cxTranslate}}
        <ul class="subregitem">
          <li class="subregitem_List" [ngClass]="{'active': getActiveSection() === 'invoice', 'inactive': getActiveSection() !== 'invoice'}">{{'progresslabel.invoiceinformation' | cxTranslate}}</li>
          <li class="subregitem_List" [ngClass]="{'active': getActiveSection() === 'paying', 'inactive': getActiveSection() !== 'paying'}">{{'progresslabel.payerinformation' | cxTranslate}}</li>
          <li class="subregitem_List" [ngClass]="{'active': getActiveSection() === 'shipping', 'inactive': getActiveSection() !== 'shipping'}">{{'progresslabel.deliverylocation' | cxTranslate}}</li>
        </ul>
      </div>
    </div>
    <div class="registration_nagivationPart" id="registration_nagivationPart4" [ngClass]="{'currentsection': getActiveSection() === 'review'}">
      <div class="registration_nagivationNo">
        <div class="registration_nagivationNumeric" >4</div>

      </div>
      <div class="registration_nagivationName" [ngClass]="{'active': getActiveSection() === 'review', 'inactive': getActiveSection() !== 'review'}">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
    </div>
  </div>
</div>
<div class="col-lg-9 col-md-8 col-sm-12 col-xs-12 registration_rightside no-padding-left no-padding-bottom">
  @if(isNonWebEnabled){
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 lo_BreadCrumbs">
      <span class="home_BreadCrumb">{{'registrataionbreadcrumbs.home' | cxTranslate}}</span>
      <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M13.2917 12.0002L9.04574 7.75423C8.95241 7.6609 8.90241 7.54623 8.89574 7.41023C8.88908 7.27423 8.93908 7.1529 9.04574 7.04623C9.15241 6.93956 9.27041 6.88623 9.39974 6.88623C9.52908 6.88623 9.64708 6.93956 9.75374 7.04623L14.1417 11.4352C14.2291 11.5219 14.2904 11.6109 14.3257 11.7022C14.3611 11.7936 14.3787 11.8929 14.3787 12.0002C14.3787 12.1076 14.3611 12.2069 14.3257 12.2982C14.2904 12.3896 14.2291 12.4789 14.1417 12.5662L9.75374 16.9542C9.66041 17.0476 9.54574 17.0976 9.40974 17.1042C9.27374 17.1109 9.15241 17.0609 9.04574 16.9542C8.93908 16.8476 8.88574 16.7296 8.88574 16.6002C8.88574 16.4709 8.93908 16.3529 9.04574 16.2462L13.2917 12.0002Z"
          fill="#2A3237" />
      </svg></span>
      @if (getActiveSection() === 'business') {
        <span class="active_BreadCrumb">{{'registrataionbreadcrumbs.businessDetails' | cxTranslate}}</span>
      }
      @if (getActiveSection() === 'invoice' || getActiveSection() === 'paying' || getActiveSection() === 'shipping') {
        <span class="active_BreadCrumb">{{'registrataionbreadcrumbs.contactAddress' | cxTranslate}}</span>
      }
      @if (getActiveSection() === 'review') {
        <span class="active_BreadCrumb">{{'registrataionbreadcrumbs.reviewConfirm' | cxTranslate}}</span>
      }
    </div>
  }
  <div class="registration_help nonweb">
    {{'bussinessDetails.Havingtrouble' | cxTranslate}}
    &nbsp;
    <a [routerLink]="'/help-and-faq'" target="_blank" class="showPopupclick">
      <span>{{'bussinessDetails.WeCanHelp' | cxTranslate}}</span>
      <div class="global_blackarrow"></div>
    </a>
  </div>
  <!--left navigation container -->
  <!--till here it will be hiden for login view -->

  <section class="registration_business registrationFlow" id="registration_section1"  [style.display]="showBussinessdetails ? 'block' : 'none'">

    <form  [formGroup]="bussinessDetails">

      <div class="registration_label padding-B10">{{'progresslabel.businessDetails' | cxTranslate}}</div>
      <div class="registration_text1 padding-B10">{{'bussinessDetails.ukcontent1' | cxTranslate}}</div>
      <div class="registration_text3">{{'bussinessDetails.content2' | cxTranslate}}</div>


      <div class="registration_existing padding-B20"> <span class="registration_question">{{'bussinessDetails.ukcontent3' | cxTranslate}} &nbsp; &nbsp;</span><a [routerLink]="'/register/join-account'" target="_blank" class="showPopupclick">{{'bussinessDetails.ukcontent4' | cxTranslate}}<div class="global_blackarrow"></div></a></div>

      <div class="padding-R15">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="business-orgname">{{'formLevel.orgname' | cxTranslate}} *</label>
          <input class="registration_input form-control" id="orgName" formControlName="orgName" autocomplete="no">
          @if (bussinessDetails.controls['orgName'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['orgName'].touched || bussinessDetails.controls['orgName'].dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (bussinessDetails.controls['orgName'].errors?.['required']) {
                <label class="error help-block">{{'formLevel.orgnameerror1' | cxTranslate}}</label>
              }
              @if (bussinessDetails.controls['orgName'].errors?.['pattern']) {
                <label class="error help-block">{{'formLevel.orgnameerror2' | cxTranslate}}</label>
              }
            </div>
          }
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
          <label class="registration_inputLabel" for="business-regnumber">{{'bussinessDetails.companyregno' | cxTranslate}}</label>
          <input class="registration_input form-control" maxlength="8" minlength="7" id="orgRegNo" formControlName="orgRegNo" autocomplete="off">

          @if (bussinessDetails.controls['orgRegNo'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['orgRegNo'].touched || bussinessDetails.controls['orgRegNo'].dirty)) {
            <div class="text-danger">
              <i class="fa-solid fa-circle-exclamation"></i>
              @if (bussinessDetails.controls['orgRegNo'].errors?.['pattern']) {
                <label class="error help-block">{{'bussinessDetails.companyregnoerror1' | cxTranslate}}</label>
              }
              @if (!bussinessDetails.controls['orgRegNo'].errors?.['pattern']) {
                <div>
                  @if (bussinessDetails.controls['orgRegNo'].errors?.['minlength']) {
                    <label class="error help-block">{{'bussinessDetails.companyregnoerror2' | cxTranslate}}</label>
                  }
                </div>
              }
            </div>
          }
          <div class="registration_text3"><i>{{'bussinessDetails.companyregnotext' | cxTranslate}}</i>
        </div>
      </div>
      <div class="clearboth"></div>
    </div>

    <div class="registration_contact padding-B20">{{'bussinessDetails.businessinformation' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group vat_InputLablel">
        <label class="registration_inputLabel" for="business-vat">{{'bussinessDetails.vatno' | cxTranslate}}</label>
        <p-inputMask class="registration_input form-control" autoClear="false"  mask="GB999999999" pattern="GB\d\d\d\d\d\d\d\d\d" id="vatNo" formControlName="vatNo"   />
        @if (bussinessDetails.controls['vatNo'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['vatNo'].touched || bussinessDetails.controls['vatNo'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['vatNo'].errors?.['pattern']) {
              <label class="error help-block">{{'bussinessDetails.vatnoerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-trade">{{'bussinessDetails.tradesince' | cxTranslate}}</label>
        <select class="registration_state form-control" id="tradingSince" name="tradingSince" formControlName="tradingSince">
          <option value="" selected="selected">YYYY</option>
          @for (year of tradingSinceYears; track year) {
            <option [value]="year">{{ year }}</option>
          }
        </select>
        @if (bussinessDetails.controls['tradingSince'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['tradingSince'].touched || bussinessDetails.controls['tradingSince'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['tradingSince'].errors?.['required']) {
              <label class="error help-block">{{'bussinessDetails.tradesinceerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 no-padding-right margin-B20  form-group business_org_Wrapper" [class.has-select-error]="bussinessDetails.controls['orgType'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['orgType'].touched || bussinessDetails.controls['orgType'].dirty)">
        <label class="registration_inputLabel " for="business-org_type">{{'bussinessDetails.orgtype' | cxTranslate}}</label>
        <select class="registration_state form-control" (change)="onOrgTypeChange($event)" id="orgType" name="orgType" formControlName="orgType">
          <option value="" selected="selected">Select</option>
          @for (type of businessTypes; track type) {
            <option [value]="type.value">{{ type.display }}</option>
          }
        </select>
        @if (bussinessDetails.controls['orgType'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['orgType'].touched || bussinessDetails.controls['orgType'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['orgType'].errors?.['required']) {
              <label class="error help-block">{{'bussinessDetails.orgtypeerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="padding-R15">

      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-nhs_code">{{'bussinessDetails.nhsCode' | cxTranslate}}</label>
        <input class="registration_input form-control" [attr.maxlength]="maxLength" maxlength="6" id="nhsCode" name="nhsCode" formControlName="nhsCode" autocomplete="off">

        @if (bussinessDetails.controls['nhsCode'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['nhsCode'].touched || bussinessDetails.controls['nhsCode'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['nhsCode'].errors?.['required']) {              
                  <div class="error help-block">                
                     {{'bussinessDetails.nhsrequired' | cxTranslate}}               
                  </div>              
              }
            <label id="business-nhs_code-error" class="error help-block" for="business-nhs_code">
              @if (bussinessDetails.controls['nhsCode'].errors?.['alphanumeric']) {
                {{'bussinessDetails.nhserror1' | cxTranslate}}
              }
              @if (!bussinessDetails.controls['nhsCode'].errors?.['alphanumeric'] && bussinessDetails.controls['nhsCode'].errors?.['pattern']) {
                @if (bussinessDetails.get('orgType')?.value === 'GENERAL_PRACTICE') {
                  <div>
                    {{'bussinessDetails.nhserror2' | cxTranslate}}
                  </div>
                }
                @if (bussinessDetails.get('orgType')?.value === 'PHARMACY') {
                  <div>
                    {{'bussinessDetails.nhserror3' | cxTranslate}}
                  </div>
                }
                @if (bussinessDetails.get('orgType')?.value === 'HOSPITAL_PUBLIC' || bussinessDetails.get('orgType')?.value === 'HOSPITAL_PRIVATE' || bussinessDetails.get('orgType')?.value === 'NURSING_HOMES' || bussinessDetails.get('orgType')?.value === 'CORRECTIONAL_FACILITY' || bussinessDetails.get('orgType')?.value === 'WHOLESALER') {
                  <div>
                    {{'bussinessDetails.nhserror4' | cxTranslate}}
                  </div>
                }
              }
            </label>
          </div>
        }
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 nhs-link-wrapper">
        <div class="ext_Pop_Link" (click)="openNhsExtPopup()">{{'registrationnhstxt.findnhscode' | cxTranslate}} <svg xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.2385 16.08C15.128 16.183 15.0393 16.3072 14.9778 16.4452C14.9163 16.5832 14.8833 16.7322 14.8806 16.8832C14.8779 17.0343 14.9057 17.1843 14.9623 17.3244C15.0189 17.4645 15.1031 17.5918 15.2099 17.6986C15.3168 17.8054 15.444 17.8896 15.5841 17.9462C15.7242 18.0028 15.8742 18.0306 16.0253 18.0279C16.1763 18.0253 16.3253 17.9922 16.4633 17.9307C16.6013 17.8692 16.7255 17.7806 16.8285 17.67L21.7035 12.795L22.5 12L21.705 11.205L16.83 6.33003C16.6179 6.125 16.3338 6.01147 16.0388 6.01389C15.7438 6.01632 15.4616 6.1345 15.2529 6.34299C15.0443 6.55147 14.9258 6.83358 14.9231 7.12855C14.9204 7.42352 15.0337 7.70776 15.2385 7.92003L18.1935 10.875H2.625C2.32663 10.875 2.04048 10.9936 1.8295 11.2045C1.61853 11.4155 1.5 11.7017 1.5 12C1.5 12.2984 1.61853 12.5845 1.8295 12.7955C2.04048 13.0065 2.32663 13.125 2.625 13.125H18.1935L15.2385 16.08Z"
              fill="#2A3237" />
          </svg>
        </div>
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="registration_contact padding-B20">{{'bussinessDetails.contactinfo' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="business-firstname" name="firstName" formControlName="firstName" autocomplete="off">
        @if (bussinessDetails.controls['firstName'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['firstName'].touched || bussinessDetails.controls['firstName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['firstName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
            }
            @if (bussinessDetails.controls['firstName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="business-lastname" name="lastName" autocomplete="off" formControlName="lastName">
        @if (bussinessDetails.controls['lastName'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['lastName'].touched || bussinessDetails.controls['lastName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['lastName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
            }
            @if (bussinessDetails.controls['lastName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="padding-R15">
      <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registrationc_parent form-group job_Title_wrapper" [class.has-select-error]="bussinessDetails.controls['jobTitle'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['jobTitle'].touched || bussinessDetails.controls['jobTitle'].dirty)">
        <label class="registration_inputLabel " for="business-jobtitle">{{'formLevel.jobtitle' | cxTranslate}}</label>
        <select class="registration_state form-control" id="business-jobtitle" name="business-jobtitle" formControlName="jobTitle">
          <option value="" selected="selected">Select</option>
          @for (item of jobTitle; track item) {
            <option selected="selected" [value]="item.value">{{ item.label }}</option>
          }
        </select>
        @if (bussinessDetails.controls['jobTitle'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['jobTitle'].touched || bussinessDetails.controls['jobTitle'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['jobTitle'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.jobtitleerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
      <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-phoneUK">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
        <input class="registration_input form-control" maxlength="11" id="business-phoneUK" name="phoneNumber" autocomplete="off" formControlName="phoneNo">
        @if (bussinessDetails.controls['phoneNo'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['phoneNo'].touched || bussinessDetails.controls['phoneNo'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['phoneNo'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
            }
            @if (bussinessDetails.controls['phoneNo'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-extn">{{'formLevel.phnext' | cxTranslate}}</label>
        <input class="registration_input form-control" maxlength="4" formControlName="phoneExt"  id="business-extn" name="phoneExt" autocomplete="off" >
        @if (bussinessDetails.controls['phoneExt'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['phoneExt'].touched || bussinessDetails.controls['phoneExt'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['phoneExt'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.phnexterror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>

    <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
      <label class="registration_inputLabel" for="business-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
      <input class="registration_input form-control" id="business-email" name="email" autocomplete="off" formControlName="emailId">
      @if (bussinessDetails.controls['emailId'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['emailId'].touched || bussinessDetails.controls['emailId'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (bussinessDetails.controls['emailId'].errors?.['required']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
          @if (bussinessDetails.controls['emailId'].errors?.['pattern']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
        </div>
      }
    </div>
    <div class="clearboth"></div>

    <div class="businessAddess">{{'bussinessDetails.businessaddress' | cxTranslate}}</div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-B20 registration_address form-group">
      <label class="registration_inputLabel " for="business-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
      <input class="registration_input form-control" id="businesslookup" name="businesslookup" >
      <span class="glyphicon glyphicon-search form-control-feedback"></span>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line1" name="line1" autocomplete="off" formControlName="line1">
        @if (bussinessDetails.controls['line1'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['line1'].touched || bussinessDetails.controls['line1'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['line1'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-addressStreet">{{'formLevel.additonalstreet' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line2" name="line2" autocomplete="off" formControlName="line2">
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-city">{{'formLevel.City' | cxTranslate}}</label>
        <input class="registration_input form-control" id="city" name="city" autocomplete="off" formControlName="city">
        @if (bussinessDetails.controls['city'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['city'].touched || bussinessDetails.controls['city'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['city'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.ukcityerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Post-Code">{{'formLevel.postcode' | cxTranslate}}</label>
        <input class="registration_input form-control" id="postalCode" name="postalCode" autocomplete="off" formControlName="postalCode">
        @if (bussinessDetails.controls['postalCode'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['postalCode'].touched || bussinessDetails.controls['postalCode'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['postalCode'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}</label>
            }
            @if (bussinessDetails.controls['postalCode'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-7 col-xs-7 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Country">{{'formLevel.country' | cxTranslate}}</label>
        <input class="registration_input form-control" id="business-country" name="country" autocomplete="off" formControlName="country">
        @if (bussinessDetails.controls['country'].invalid && (isFormSubmitted_bussiness || bussinessDetails.controls['country'].touched || bussinessDetails.controls['country'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (bussinessDetails.controls['country'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.countryerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <button type="button" (click)="onSubmit_bussiness()" class="registration_save active" id="registration_save">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
  </form>
</section>
<!-- business details end here -->
<section class="registration_billing registrationFlow" id="registration_section2" [style.display]="showInvoicedetails ? 'block' : 'none'">
  <form [formGroup]="billingDetails">
    <div class="registration_label padding-B10">{{'progresslabel.invoiceinformation' | cxTranslate}}</div>
    <div class="registration_text1 padding-B10">{{'billinginfo.content1' | cxTranslate}}</div>
    <div class="registration_text2">{{'bussinessDetails.content2' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="margin-B20 registration_reviewCheckbox registration_parent registration_checkparent">
        <label class="checkbox-button">
          <input type="checkbox" (change)="copyBusinessToBilling($event)" class="registration_checkbox" id="busi-invoice_check" name="busi-invoice_check">
          <span class="checkbox-button__control"></span>
        </label>
        <label class="registration_checkboxLabel copy_CheckBoxLabel">{{'billinginfo.copybusinesscontact' | cxTranslate}}</label>
        <div class="clearboth"></div>
      </div>
    </div>
    <div class="registration_contact padding-B20">{{'billinginfo.invoicingcontact' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="billing-firstname"  autocomplete="off" formControlName="firstName" >
        @if (billingDetails.controls['firstName'].invalid && (isFormSubmitted_billing || billingDetails.controls['firstName'].touched || billingDetails.controls['firstName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['firstName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
            }
            @if (billingDetails.controls['firstName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="billing-lastname"  autocomplete="off" formControlName="lastName" >
        @if (billingDetails.controls['lastName'].invalid && (isFormSubmitted_billing || billingDetails.controls['lastName'].touched || billingDetails.controls['lastName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['lastName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
            }
            @if (billingDetails.controls['lastName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
   
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-phoneUK">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
        <input class="registration_input form-control" maxlength="11" id="business-phoneUK" name="phoneNumber" autocomplete="off" formControlName="phone">
        @if (billingDetails.controls['phone'].invalid && (isFormSubmitted_billing || billingDetails.controls['phone'].touched || billingDetails.controls['phone'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['phone'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
            }
            @if (billingDetails.controls['phone'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-extn">{{'formLevel.phnext' | cxTranslate}}</label>
        <input class="registration_input form-control" formControlName="phoneExt"  maxlength="4" autocomplete="off">
        @if (billingDetails.controls['phoneExt'].invalid && (isFormSubmitted_billing || billingDetails.controls['phoneExt'].touched || billingDetails.controls['phoneExt'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['phoneExt'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.phnexterror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
      <label class="registration_inputLabel" for="billing-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
      <input class="registration_input form-control" id="billing-email" autocomplete="off" formControlName="email">
      @if (billingDetails.controls['email'].invalid && (isFormSubmitted_billing || billingDetails.controls['email'].touched
      || billingDetails.controls['email'].dirty)) {
      <div class="text-danger">
        <i class="fa-solid fa-circle-exclamation"></i>
        @if (billingDetails.controls['email'].errors?.['required']) {
        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
        }
        @if (billingDetails.controls['email'].errors?.['pattern']) {
        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
        }
      </div>
      }
    </div>
     <div class="clearboth"></div>
    <div class="registration_contact padding-B20">{{'billinginfo.invoicingaddress' | cxTranslate}}</div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
      <label class="registration_inputLabel" for="billing-orgname">{{'formLevel.orgname' | cxTranslate}} *</label>
      <input class="registration_input form-control" id="orgName" formControlName="orgName" autocomplete="no">
      @if (billingDetails.controls['orgName'].invalid && (isFormSubmitted_billing || billingDetails.controls['orgName'].touched || billingDetails.controls['orgName'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (billingDetails.controls['orgName'].errors?.['required']) {
            <label class="error help-block">{{'formLevel.orgnameerror1' | cxTranslate}}</label>
          }
          @if (billingDetails.controls['orgName'].errors?.['pattern']) {
            <label class="error help-block">{{'formLevel.orgnameerror2' | cxTranslate}}</label>
          }
        </div>
      }
    </div>
    <div class="clearboth"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-B30 registration_address form-group">
      <label class="registration_inputLabel" for="billing-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
      <input class="registration_input form-control"  id="billinglookup"   name="billinglookup" >
      <span class="glyphicon glyphicon-search form-control-feedback"></span>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line1" name="line1_billing" autocomplete="off" formControlName="line1">
        @if (billingDetails.controls['line1'].invalid && (isFormSubmitted_billing || billingDetails.controls['line1'].touched || billingDetails.controls['line1'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['line1'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-addressStreet">{{'formLevel.additonalstreet' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line2" name="line2_billing" autocomplete="off" formControlName="line2">
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-city">{{'formLevel.City' | cxTranslate}}</label>
        <input class="registration_input form-control" id="city" name="city_billing" autocomplete="off" formControlName="city">
        @if (billingDetails.controls['city'].invalid && (isFormSubmitted_billing || billingDetails.controls['city'].touched || billingDetails.controls['city'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['city'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.ukcityerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Post-Code">{{'formLevel.postcode' | cxTranslate}}</label>
        <input class="registration_input form-control" id="postalCode" name="postalCode_billing" autocomplete="off" formControlName="postalCode">
        @if (billingDetails.controls['postalCode'].invalid && (isFormSubmitted_billing || billingDetails.controls['postalCode'].touched || billingDetails.controls['postalCode'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['postalCode'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}</label>
            }
            @if (billingDetails.controls['postalCode'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}.</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-7 col-xs-7 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Country">{{'formLevel.country' | cxTranslate}}</label>
        <input class="registration_input form-control" id="business-country" name="country_billing" autocomplete="off" formControlName="country">
        @if (billingDetails.controls['country'].invalid && (isFormSubmitted_billing || billingDetails.controls['country'].touched || billingDetails.controls['country'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (billingDetails.controls['country'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.countryerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="registration_contact padding-B20">{{'billinginfo.CommunicationPreferences' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="margin-B20 registration_reviewCheckbox registration_parent registration_checkparent">
        <label class="checkbox-button">
          <input type="checkbox" class="registration_checkbox" id="alt_email" name="alt_email" (change)="toggleAcctStmtEmail($event)">
          <span class="checkbox-button__control"></span>
        </label>
        <label class="registration_checkboxLabel">{{'billinginfo.usealternateemailtext' | cxTranslate}}</label>
        <div class="clearboth"></div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding margin-B20 registration_parent form-group" id="bill-accemail">
      <label class="registration_inputLabel " for="billing-alt_email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
      <input class="registration_input form-control" id="billing-alt_email" name="acctStmtEmail" formControlName="acctStmtEmail" autocomplete="off">
      @if (billingDetails.controls['acctStmtEmail'].invalid && (isFormSubmitted_billing || billingDetails.controls['acctStmtEmail'].touched || billingDetails.controls['acctStmtEmail'].dirty)) {
        <div class="text-danger">
          @if (billingDetails.controls['acctStmtEmail'].errors?.['required']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
          @if (billingDetails.controls['acctStmtEmail'].errors?.['pattern']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
        </div>
      }
    </div>
    <div class="clearboth"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
      <div class="registration_back active" (click)="showBussinessSection()">
        <div class="global_blackarrow"></div>
        <span>{{'formLevel.Back' | cxTranslate}}</span>
        <div class="clearboth"></div>
      </div>
      <button type="button" class="registration_save active" id="registration_save" (click)="onSubmit_billing()">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
      <div class="clearboth"></div>
    </div>

  </form>
</section>
<!--Invoice Information end here-->

<section class="registration_billing registrationFlow" id="registration_section2" [style.display]="showPayingdetails ? 'block' : 'none'">
  <form [formGroup]="payerDetails">
    <div class="registration_label padding-B10">{{'progresslabel.payerinformation' | cxTranslate}}</div>
    <div class="registration_text1 padding-B10">{{'payinginfo.content1' | cxTranslate}}</div>
    <div class="registration_text2">{{'bussinessDetails.content2' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="margin-B20 registration_reviewCheckbox registration_parent registration_checkparent">
        <label class="checkbox-button">
          <input type="checkbox" (change)="copyBillingToPaying($event)" class="registration_checkbox" id="busi-invoice_check" name="busi-invoice_check">
          <span class="checkbox-button__control"></span>
        </label>
        <label class="registration_checkboxLabel copy_CheckBoxLabel">{{'payinginfo.copyinvoicecontact' | cxTranslate}}</label>
        <div class="clearboth"></div>
      </div>
    </div>
    <div class="registration_contact padding-B20">{{'payinginfo.payercontact' | cxTranslate}}</div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="billing-firstname"  autocomplete="off" formControlName="firstName" >
        @if (payerDetails.controls['firstName'].invalid && (isFormSubmitted_paying || payerDetails.controls['firstName'].touched || payerDetails.controls['firstName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['firstName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
            }
            @if (payerDetails.controls['firstName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
        <input class="registration_input form-control" id="billing-lastname"  autocomplete="off" formControlName="lastName" >
        @if (payerDetails.controls['lastName'].invalid && (isFormSubmitted_paying || payerDetails.controls['lastName'].touched || payerDetails.controls['lastName'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['lastName'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
            }
            @if (payerDetails.controls['lastName'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="clearboth"></div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-phoneUK">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
        <input class="registration_input form-control" maxlength="11" id="business-phoneUK" name="phoneNumber"
          autocomplete="off" formControlName="phone">
        @if (payerDetails.controls['phone'].invalid && (isFormSubmitted_paying || payerDetails.controls['phone'].touched ||
        payerDetails.controls['phone'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (payerDetails.controls['phone'].errors?.['required']) {
          <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
          }
          @if (payerDetails.controls['phone'].errors?.['pattern']) {
          <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
          }
        </div>
        }
      </div>
      <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="billing-extn">{{'formLevel.phnext' | cxTranslate}}</label>
        <input class="registration_input form-control" formControlName="phoneExt" maxlength="4" autocomplete="off">
        @if (payerDetails.controls['phoneExt'].invalid && (isFormSubmitted_paying ||
        payerDetails.controls['phoneExt'].touched || payerDetails.controls['phoneExt'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (payerDetails.controls['phoneExt'].errors?.['pattern']) {
          <label class="error help-block">{{'formLevel.phnexterror' | cxTranslate}}</label>
          }
        </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
      <label class="registration_inputLabel" for="billing-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
      <input class="registration_input form-control" id="billing-email"  autocomplete="off" formControlName="email" >
      @if (payerDetails.controls['email'].invalid && (isFormSubmitted_paying || payerDetails.controls['email'].touched || payerDetails.controls['email'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (payerDetails.controls['email'].errors?.['required']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
          @if (payerDetails.controls['email'].errors?.['pattern']) {
            <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
          }
        </div>
      }
    </div>
    <div class="clearboth"></div>

    <div class="registration_contact padding-B20">{{'payinginfo.PayerAddress' | cxTranslate}}</div>
    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
      <label class="registration_inputLabel" for="billing-orgname">{{'formLevel.orgname' | cxTranslate}} *</label>
      <input class="registration_input form-control" id="orgName" formControlName="orgName" autocomplete="no">
      @if (payerDetails.controls['orgName'].invalid && (isFormSubmitted_paying || payerDetails.controls['orgName'].touched || payerDetails.controls['orgName'].dirty)) {
        <div class="text-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          @if (payerDetails.controls['orgName'].errors?.['required']) {
            <label class="error help-block">{{'formLevel.orgnameerror1' | cxTranslate}}</label>
          }
          @if (payerDetails.controls['orgName'].errors?.['pattern']) {
            <label class="error help-block">{{'formLevel.orgnameerror2' | cxTranslate}}</label>
          }
        </div>
      }
    </div>
    <div class="clearboth"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-B30 registration_address form-group">
      <label class="registration_inputLabel" for="billing-lookup">{{'formLevel.AddressLookup' | cxTranslate}}</label>
      <input class="registration_input form-control"  id="payinglookup"   name="payinglookup" >
      <span class="glyphicon glyphicon-search form-control-feedback"></span>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line1" name="line1_paying" autocomplete="off" formControlName="line1">
        @if (payerDetails.controls['line1'].invalid && (isFormSubmitted_paying || payerDetails.controls['line1'].touched || payerDetails.controls['line1'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['line1'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-addressStreet">{{'formLevel.additonalstreet' | cxTranslate}}</label>
        <input class="registration_input form-control" id="line2" name="line2_paying" autocomplete="off" formControlName="line2">
      </div>
      <div class="clearboth"></div>
    </div>
    <div class="padding-R15">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
        <label class="registration_inputLabel" for="business-city">{{'formLevel.City' | cxTranslate}}</label>
        <input class="registration_input form-control" id="city" name="city_paying" autocomplete="off" formControlName="city">
        @if (payerDetails.controls['city'].invalid && (isFormSubmitted_paying || payerDetails.controls['city'].touched || payerDetails.controls['city'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['city'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.ukcityerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-5 col-xs-5 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Post-Code">{{'formLevel.postcode' | cxTranslate}}</label>
        <input class="registration_input form-control" id="postalCode" name="postalCode_paying" autocomplete="off" formControlName="postalCode">
        @if (payerDetails.controls['postalCode'].invalid && (isFormSubmitted_paying || payerDetails.controls['postalCode'].touched || payerDetails.controls['postalCode'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['postalCode'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}</label>
            }
            @if (payerDetails.controls['postalCode'].errors?.['pattern']) {
              <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}.</label>
            }
          </div>
        }
      </div>
      <div class="col-lg-3 col-md-3 col-sm-7 col-xs-7 no-padding-right margin-B20 registration_parent form-group">
        <label class="registration_inputLabel " for="business-Country">{{'formLevel.country' | cxTranslate}}</label>
        <input class="registration_input form-control" id="business-country" name="country_paying" autocomplete="off" formControlName="country">
        @if (payerDetails.controls['country'].invalid && (isFormSubmitted_paying || payerDetails.controls['country'].touched || payerDetails.controls['country'].dirty)) {
          <div class="text-danger">
            <i class="fa-solid fa-circle-exclamation"></i>
            @if (payerDetails.controls['country'].errors?.['required']) {
              <label class="error help-block">{{'formLevel.countryerror' | cxTranslate}}</label>
            }
          </div>
        }
      </div>
      <div class="clearboth"></div>
    </div>

    <div class="clearboth"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
      <div class="registration_back active" (click)="showBillingSection()">
        <div class="global_blackarrow"></div>
        <span>{{'formLevel.Back' | cxTranslate}}</span>
        <div class="clearboth"></div>
      </div>
      <button type="button" class="registration_save active" id="registration_save" (click)="onSubmit_paying()">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
      <div class="clearboth"></div>
    </div>

  </form>
</section>



<!--Payer Information end here-->




<section class="registration_shipping registrationFlow" id="registration_section4" [style.display]="showShippingdetails ? 'block' : 'none'">
  <form id="shippingForm" [formGroup]="shippingForm">
    <div formArrayName="shippingList">
      <div class="registration_label padding-B10">{{'Shippinglocations.deliverylocation' | cxTranslate}}</div>


      <div class="registration_text1 padding-B10">{{'Shippinglocations.ukcontent1' | cxTranslate}}</div>
      <div class="registration_text2">{{'Shippinglocations.ukcontent2' | cxTranslate}}</div>
      @if (showCheckbox) {
        <div class="padding-R15 org_ship">
          <div  class="margin-B20 registration_reviewCheckbox registration_parent registration_checkparent">
            <label class="checkbox-button">
              <input type="checkbox" class="registration_checkbox" id="org-shipping_check" name="org-shipping_check" (change)="copyBusinessToShipping($event, 0)">
              <span class="checkbox-button__control"></span>
            </label>
            <label class="registration_checkboxLabel copy_CheckBoxLabel">{{'Shippinglocations.copyorgcontact' | cxTranslate}}</label>
            <div class="clearboth"></div>
          </div>
        </div>
      }

      <div class="print_shipping">

      </div>


      @for (shipping of shippingList.controls; track shipping; let i = $index) {
        <div class="shipping-blk"  [formGroupName]="i">
          @if (!shipping.get('isEditing')?.value && shipping.get('submitted')?.value) {
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 registration_locations" [style.display]="shipping.get('submitted')?.value ? 'block' : 'none'">
              <div class="registration_locationparent">
                <div class="registration_locationLine1">
                  <div class="registration_locationName">{{'Shippinglocations.Location' | cxTranslate}} <span class="locationno">{{ i + 1 }}</span></div>
                  <div class="registration_locationOrg">{{ shipping.get('orgName')?.value }}</div>
                  <div class="clearboth"></div>
                </div>
                <div class="registration_edit ship_del" (click)="removeShippingForm(i)">{{'Shippinglocations.Remove' | cxTranslate}} <i class="fa fa-trash" aria-hidden="true"></i></div>
                <div class="registration_edit only_edit_ship" [class.disabled]="isAnyFormEditing && !shipping.get('isEditing')?.value" (click)="!isAnyFormEditing && toggleShipping(i)">{{'formLevel.edit' | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
                <div class="clearboth"></div>
              </div>
              <div class="registration_locationLine2">
                <div class="registration_locationcontact">
                  <div class="registration_locationcontactline1">{{'Shippinglocations.contactinfo' | cxTranslate}} </div>
                  <div class="registration_locationcontactname">
                    <span>{{ shipping.get('firstName')?.value }}</span>&nbsp; <span>{{ shipping.get('lastName')?.value }}</span>
                  </div>
                  <div class="registration_locationcontactemail">
                    <span>{{ shipping.get('email')?.value }}</span>
                  </div>
                  <div class="registration_locationcontactphn">
                    <span>{{ shipping.get('phone')?.value }}</span> ext. <span>{{ shipping.get('phoneExt')?.value }}</span>
                  </div>
                </div>
                <div class="registration_locationaddress">
                  <div class="registration_locationcontactline1">{{'reviewpage.address' | cxTranslate}}</div>
                  <div class="registration_locationaddress1">
                    <span>{{ shipping.get('line1')?.value }}</span>
                  </div>
                  <div class="registration_locationaddress2">
                    <span>{{ shipping.get('line2')?.value }}</span>
                  </div>
                  <div class="registration_locationaddress4">
                    <span>{{ shipping.get('city')?.value }}</span>,<span>{{ shipping.get('postalCode')?.value }}</span><br/>
                    <span>{{ shipping.get('country')?.value }}</span>
                  </div>
                </div>
                <div class="registration_locationLic">
                  <div class="registration_locationcontactline1">{{'Shippinglocations.License' | cxTranslate}} </div>
                  <div class="registration_locationlic1">
                    <span>{{ shipping.get('licenseDetailsForm.licenseName')?.value }}</span> - <span>{{ shipping.get('licenseDetailsForm.licenseNum')?.value }}</span>
                  </div>
                  <div class="registration_locationlic3">
                    <span>{{ shipping.get('licenseDetailsForm.nhsCode')?.value }}</span>
                  </div>
                </div>
                <div class="clearboth"></div>
              </div>
            </div>
          }
          @if (!shipping.get('submitted')?.value || shipping.get('isEditing')?.value) {
            <div class="shipping-block" [ngClass]="{'registration_locations': shipping.get('isEditing')?.value}">
              @if (showLocationcount) {
                <div class="locationtitel">{{'Shippinglocations.Location' | cxTranslate}}  <span class="locationno1">{{i+1}}</span></div>
              }
              <div class="registration_contact padding-B20">
                {{'Shippinglocations.deliveryloccontact' | cxTranslate}}&nbsp;&nbsp;<span [attr.tooltip]="tooltipText1" tooltip-position="buttom" ><i class="fa fa-question-circle-o" ></i></span>
                @if ((shipping.get('isEditing')?.value || isAddingNewForm) && shippingList.length > 1) {
                  <div class="registration_edit"  (click)="removeShippingForm(i)">{{'Shippinglocations.Remove' | cxTranslate}} <span class="editiconpadd"> <i class="fa fa-trash" aria-hidden="true"></i></span></div>
                }
              </div>
              <div class="padding-R15">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="business-firstname">{{'formLevel.firstName' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="business-firstname" formControlName="firstName" autocomplete="off">
                  @if (shipping.get('firstName')!.invalid && (isFormSubmitted_shipping || shipping.get('firstName')!.touched || shipping.get('firstName')!.dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (shipping.get('firstName')!.errors?.['required']) {
                        <label class="error help-block">{{'formLevel.firstNameError1' | cxTranslate}}</label>
                      }
                      @if (shipping.get('firstName')!.errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.firstNameError2' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="business-lastname">{{'formLevel.lastName' | cxTranslate}}</label>
                  <input class="registration_input form-control" id="business-lastname" formControlName="lastName" autocomplete="off">
                  @if (shipping.get('lastName')!.invalid && (isFormSubmitted_shipping || shipping.get('lastName')!.touched || shipping.get('lastName')!.dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (shipping.get('lastName')!.errors?.['required']) {
                        <label class="error help-block">{{'formLevel.lastNameError1' | cxTranslate}}</label>
                      }
                      @if (shipping.get('lastName')!.errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.lastNameError2' | cxTranslate}}</label>
                      }
                    </div>
                  }
                  <div class="clearboth"></div>
                </div>
                <div class="clearboth"></div>
                <div class="padding-R15">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-phno">{{'formLevel.PhoneNumber' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" maxlength="11" id="shipping-phno" formControlName="phone" autocomplete="no">
                    @if (shipping.get('phone')!.invalid && (isFormSubmitted_shipping || shipping.get('phone')!.touched || shipping.get('phone')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('phone')!.errors?.['required']) {
                          <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
                        }
                        @if (shipping.get('phone')!.errors?.['pattern']) {
                          <label class="error help-block">{{'formLevel.ukphonenumbererror' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-extension">{{'formLevel.phnext' | cxTranslate}}</label>
                    <input class="registration_input form-control" maxlength="4" id="shipping-extension" formControlName="phoneExt" autocomplete="no">
                    @if (shipping.get('phoneExt')!.invalid && (isFormSubmitted_shipping || shipping.get('phoneExt')!.touched || shipping.get('phoneExt')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('phoneExt')!.errors?.['pattern']) {
                          <label class="error help-block">{{'formLevel.phnexterror' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="clearboth"></div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding-left margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="shipping-email">{{'formLevel.EmailAddress' | cxTranslate}}</label>
                  <input class="registration_input form-control field_mandatory" id="shipping-email" formControlName="email" autocomplete="no">
                  @if (shipping.get('email')!.invalid && (isFormSubmitted_shipping || shipping.get('email')!.touched || shipping.get('email')!.dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (shipping.get('email')!.errors?.['required']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                      @if (shipping.get('email')!.errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.EmailAddressError1' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="clearboth"></div>

                <div class="registration_contact padding-B20">{{'Shippinglocations.deliveryaddress' | cxTranslate}}</div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-padding-left margin-B20 registration_parent form-group">
                  <label class="registration_inputLabel" for="shipping-orgname">{{'formLevel.orgname' | cxTranslate}}</label>
                  <input class="registration_input form-control field_mandatory" id="shipping-orgname" formControlName="orgName" autocomplete="no">
                  @if (shipping.get('orgName')!.invalid && (isFormSubmitted_shipping || shipping.get('orgName')!.touched || shipping.get('orgName')!.dirty)) {
                    <div class="text-danger">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      @if (shipping.get('orgName')!.errors?.['required']) {
                        <label class="error help-block">{{'formLevel.orgnameerror1' | cxTranslate}}</label>
                      }
                      @if (shipping.get('orgName')!.errors?.['pattern']) {
                        <label class="error help-block">{{'formLevel.orgnameerror2' | cxTranslate}}</label>
                      }
                    </div>
                  }
                </div>
                <div class="clearboth"></div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left margin-B30 registration_address form-group">
                  <label class="registration_inputLabel" for="shipping-lookup1">{{'formLevel.AddressLookup' | cxTranslate}}</label>
                  <input class="registration_input form-control" [id]="'shipping_lookup'+i"  [name]="'shipping_lookup'+i" >
                  <span class="glyphicon glyphicon-search form-control-feedback"></span>
                </div>
                <div class="padding-R15">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-left margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-address1">{{'formLevel.AddressLine1' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" id="shipping-address1" name="line1{{i}}" formControlName="line1" autocomplete="no">
                    @if (shipping.get('line1')!.invalid && (isFormSubmitted_shipping || shipping.get('line1')!.touched || shipping.get('line1')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('line1')!.errors?.['required']) {
                          <label class="error help-block">{{'formLevel.AddressLine1Error' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-addressStreet">{{'formLevel.additonalstreet' | cxTranslate}}</label>
                    <input class="registration_input form-control" id="shipping-addressStreet" formControlName="line2" name="line2{{i}}" autocomplete="no">
                  </div>
                  <div class="clearboth"></div>
                </div>
                <div class="padding-R15">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-left margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-city1">{{'formLevel.City' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" id="shipping-city1" name="city{{i}}" formControlName="city"  autocomplete="no">
                    @if (shipping.get('city')!.invalid && (isFormSubmitted_shipping || shipping.get('city')!.touched || shipping.get('city')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('city')!.errors?.['required']) {
                          <label class="error help-block">{{'formLevel.ukcityerror' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-5 col-xs-5 no-padding-right margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-Post-Code">{{'formLevel.postcode' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" id="shipping-postcode" name="postalCode{{i}}" formControlName="postalCode" autocomplete="off">
                    @if (shipping.get('postalCode')!.invalid && (isFormSubmitted_shipping || shipping.get('postalCode')!.touched || shipping.get('postalCode')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('postalCode')!.errors?.['required']) {
                          <label class="error help-block">{{'formLevel.postcodeerror' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-4 col-md-3 col-sm-7 col-xs-7 no-padding-right margin-B20 form-group">
                    <label class="registration_inputLabel" for="shipping-Country">{{'formLevel.country' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" id="shipping-country" name="country{{i}}"   formControlName="country" autocomplete="off">
                    @if (shipping.get('country')!.invalid && (isFormSubmitted_shipping || shipping.get('country')!.touched || shipping.get('country')!.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('country')!.errors?.['required']) {
                          <label class="error help-block">{{'formLevel.countryerror' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="clearboth"></div>
                </div>
                <div class="registration_contact padding-B10">{{'Shippinglocations.licenseinfo' | cxTranslate}}</div>
                <div class="registration_text2"><i>{{'Shippinglocations.licensecontent' | cxTranslate}}</i></div>
                <div class="padding-R15" [formGroupName]="'licenseDetailsForm'">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-licensename">{{'Shippinglocations.licensename' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" id="shipping-licensename" formControlName="licenseName" autocomplete="off">
                    @if (shipping.get('licenseDetailsForm.licenseName')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseName')?.touched || shipping.get('licenseDetailsForm.licenseName')?.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('licenseDetailsForm.licenseName')?.errors?.['required']) {
                          <label class="error help-block">{{'Shippinglocations.licensenameerror1' | cxTranslate}}</label>
                        }
                        @if (shipping.get('licenseDetailsForm.licenseName')?.errors?.['pattern']) {
                          <label class="error help-block">{{'Shippinglocations.licensenameerror2' | cxTranslate}}</label>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-right margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-licenseno">{{'Shippinglocations.licensenum' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" maxlength="7" id="shipping-licenseno" formControlName="licenseNum" autocomplete="no">
                    @if (shipping.get('licenseDetailsForm.licenseNum')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.licenseNum')?.touched || shipping.get('licenseDetailsForm.licenseNum')?.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('licenseDetailsForm.licenseNum')?.errors?.['required']) {
                          <label class="error help-block">{{'Shippinglocations.licensenumerror1' | cxTranslate}}</label>
                        }
                        @if (shipping.get('licenseDetailsForm.licenseNum')?.errors?.['pattern']) {
                          <label class="error help-block">{{'Shippinglocations.licensenumerror2' | cxTranslate}}</label>
                        }
                        @if (!shipping.get('licenseDetailsForm.licenseNum')?.errors?.['pattern']) {
                          <div>
                            @if (shipping.get('licenseDetailsForm.licenseNum')?.errors?.['minlength']) {
                              <label class="error help-block">{{'Shippinglocations.licensenumerror3' | cxTranslate}}</label>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="clearboth"></div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding-left margin-B20 registration_parent form-group">
                    <label class="registration_inputLabel" for="shipping-nhs">{{'bussinessDetails.nhsCode' | cxTranslate}}</label>
                    <input class="registration_input form-control field_mandatory" maxlength="6" id="shipping-nhs" formControlName="nhsCode" autocomplete="no">
                    @if (shipping.get('licenseDetailsForm.nhsCode')?.invalid && (isFormSubmitted_shipping || shipping.get('licenseDetailsForm.nhsCode')?.touched || shipping.get('licenseDetailsForm.nhsCode')?.dirty)) {
                      <div class="text-danger">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        @if (shipping.get('licenseDetailsForm.nhsCode')?.errors?.['required']) {
                          <div>
                            <label id="shipping-nhs_code-error" class="error help-block"for="shipping-nhs">
                              {{'bussinessDetails.nhsrequired' | cxTranslate}}
                            </label>
                          </div>
                        }
                        @if (shipping.get('licenseDetailsForm.nhsCode')?.errors?.['alphanumeric']) {
                          <div>
                            <label id="shipping-nhs_code-error" class="error help-block" for="shipping-nhs">{{'bussinessDetails.nhserror1' | cxTranslate}}</label>
                          </div>
                        }
                        @if (!shipping.get('licenseDetailsForm.nhsCode')?.errors?.['alphanumeric'] && shipping.get('licenseDetailsForm.nhsCode')?.errors?.['pattern']) {
                          <div>
                            @if (bussinessDetails.get('orgType')?.value === 'GENERAL_PRACTICE') {
                              <div>
                                <label id="shipping-nhs_code-error" class="error help-block" for="shipping-nhs">{{'bussinessDetails.nhserror2' | cxTranslate}}</label>
                              </div>
                            }
                            @if (bussinessDetails.get('orgType')?.value === 'PHARMACY') {
                              <div>
                                <label id="shipping-nhs_code-error" class="error help-block" for="shipping-nhs">{{'bussinessDetails.nhserror3' | cxTranslate}}</label>
                              </div>
                            }
                            @if (bussinessDetails.get('orgType')?.value === 'HOSPITAL_PUBLIC' || bussinessDetails.get('orgType')?.value === 'HOSPITAL_PRIVATE' || bussinessDetails.get('orgType')?.value === 'NURSING_HOMES' || bussinessDetails.get('orgType')?.value === 'CORRECTIONAL_FACILITY' || bussinessDetails.get('orgType')?.value === 'WHOLESALER') {
                              <div>
                                <label id="shipping-nhs_code-error" class="error help-block" for="shipping-nhs">{{'bussinessDetails.nhserror4' | cxTranslate}}</label>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-5 col-md-4 col-sm-12 col-xs-12 nhs-link-wrapper">
                    <div class="ext_Pop_Link" (click)="openNhsExtPopup()">{{'registrationnhstxt.findnhscode' | cxTranslate}} <svg xmlns="http://www.w3.org/2000/svg"
                        width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M15.2385 16.08C15.128 16.183 15.0393 16.3072 14.9778 16.4452C14.9163 16.5832 14.8833 16.7322 14.8806 16.8832C14.8779 17.0343 14.9057 17.1843 14.9623 17.3244C15.0189 17.4645 15.1031 17.5918 15.2099 17.6986C15.3168 17.8054 15.444 17.8896 15.5841 17.9462C15.7242 18.0028 15.8742 18.0306 16.0253 18.0279C16.1763 18.0253 16.3253 17.9922 16.4633 17.9307C16.6013 17.8692 16.7255 17.7806 16.8285 17.67L21.7035 12.795L22.5 12L21.705 11.205L16.83 6.33003C16.6179 6.125 16.3338 6.01147 16.0388 6.01389C15.7438 6.01632 15.4616 6.1345 15.2529 6.34299C15.0443 6.55147 14.9258 6.83358 14.9231 7.12855C14.9204 7.42352 15.0337 7.70776 15.2385 7.92003L18.1935 10.875H2.625C2.32663 10.875 2.04048 10.9936 1.8295 11.2045C1.61853 11.4155 1.5 11.7017 1.5 12C1.5 12.2984 1.61853 12.5845 1.8295 12.7955C2.04048 13.0065 2.32663 13.125 2.625 13.125H18.1935L15.2385 16.08Z"
                          fill="#2A3237" />
                      </svg>
                    </div>
                  </div>
                  <div class="clearboth"></div>
                  <div class="col-md-12">@if (shipping.get('isEditing')?.value) {
                    <button type="button" class="shipping_edit_save" (click)="modifyForm(i, shipping.value)">{{'formLevel.save' | cxTranslate}}</button>
                  }</div>
                </div>
                <div class="clearboth"></div>
              </div>
            </div>
          }
          <div class="clearboth"></div>
          @if (i === shippingList.controls.length - 1) {
            <div >
              @if (!toggleButtonVisibility(i)) {
                <div class="registration_addbutton margin-B20" (click)="addAnotherLocation(i)" [ngClass]="{'registration_addbutton_disable': !checkFormValidity(i)}">{{'Shippinglocations.AddAnotherLocation' | cxTranslate}} &nbsp;<span class="glyphicon glyphicon-remove-circle"></span></div>
              }
              @if (toggleButtonVisibility(i) && !isAnyFormEditing) {
                <div class="margin-B20 only_show_field" (click)="addShippingForm()" >{{'Shippinglocations.AddAnotherLocation' | cxTranslate}} &nbsp;<span class="glyphicon glyphicon-remove-circle"></span></div>
              }
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
                <div class="registration_back active" (click)="showPayingSection()">
                  <div class="global_blackarrow"></div>
                  <span>{{'formLevel.Back' | cxTranslate}}</span>
                  <div class="clearboth"></div>
                </div>
                <button type="button" class="registration_save active" id="registration_save"  (click)="onSubmit_shipping(i)">{{'formLevel.SaveandContinue' | cxTranslate}}</button>
                <div class="clearboth"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </form>
</section>
<!--Shipping Information end here-->


<section class="registration_review registrationFlow" id="registration_section5"  [style.display]="showReviewdetails ? 'block' : 'none'">
  <form id="reviewForm" novalidate="novalidate" data-gtm-vis-recent-on-screen55327271_215="1160805" data-gtm-vis-first-on-screen55327271_215="1160805" data-gtm-vis-total-visible-time55327271_215="100" data-gtm-vis-has-fired55327271_215="1">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left registration_label padding-B10">{{'reviewpage.title' | cxTranslate}}</div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding-left registration_text1 padding-B20">{{'reviewpage.content' | cxTranslate}}</div>
    <div class="clearboth"></div>
    <div class="registration_reviewContainer">
      @if (userData) {
        <div class="registration_reviewProfile padding-B20">
          <div class="registration_reviewlabel1">{{'reviewpage.profile' | cxTranslate}}</div>
          <div class="clearboth"></div>
          <div class="registration_reviewlabel2 margin-B10">{{'reviewpage.logininfo' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewemail1">{{userData.email}}</div>
          <!-- <div class="registration_populate registration_reviewpassword" id="reviewLoginPassword">***********</div> -->
          <div class="registration_reviewlabel2 margin-T25 margin-B10">{{'reviewpage.contactinfo' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewname" id="reviewName">{{userData.firstName}}&nbsp;{{userData.lastName}}</div>
          <div class="registration_populate registration_reviewBuyer" id="reviewJob">{{userData.jobTitle}}</div>
          <div class="registration_populate registration_reviewemail" id="reviewContactEmail">{{userData.email}}</div>
          <div class="registration_populate registration_reviewPh reviewcdcphonehead">
            <div id="reviewPhone">{{userData.phone}}</div>
            <div class="reviewcdcphone">{{'formLevel.phnext' | cxTranslate}}</div>
            <div class="reviewcdcphone" id="reviewPhoneext">{{userData.phoneExt}}</div>
          </div>
        </div>
      }
      @if (formDataBussiness) {
        <div class="registration_reviewBusiness padding-B20">
          <div class="registration_reviewparent">
            <div class="registration_reviewlabel1">{{'progresslabel.businessDetails' | cxTranslate}}</div>
            <div class="registration_edit" id="registration_Businessedit" (click)="showBussinessSection()">{{'formLevel.edit' | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
            <div class="clearboth"></div>
          </div>
          <div class="registration_reviewlabel2 margin-B10">{{'reviewpage.orginfo' | cxTranslate}}</div>
          <div class="registration_populate registration_companyName" id="review-orgname">{{ formDataBussiness.orgName}}</div>
          <div class="registration_populate registration_duns" id="review-reg">{{'reviewpage.companyRegNo' | cxTranslate}} {{ formDataBussiness.orgRegNo}}</div>
          <div class="registration_populate registration_vat" id="review-vat">{{'reviewpage.vatno' | cxTranslate}} {{ formDataBussiness.vatNo}}</div>
          <div class="registration_populate registration_tading" id="review-trade">{{'reviewpage.tradingsince' | cxTranslate}} {{ formDataBussiness.tradingSince}}</div>
          <div class="registration_populate registration_orgtype" id="review-orgtype">{{'reviewpage.orgtype' | cxTranslate}} {{ formattedBusinessType }}</div>
          <div class="registration_populate registration_nhscode" id="review-nhscode">{{'reviewpage.nhscode' | cxTranslate}} {{ formDataBussiness.nhsCode}}</div>
          <div class="registration_reviewlabel2 margin-T25 margin-B10">{{'reviewpage.contactinfo' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewname" id="review-business-name">{{ formDataBussiness.firstName}}&nbsp;{{ formDataBussiness.lastName}} </div>
          <div class="registration_populate registration_jobtitle" id="review-jobtitle">{{ formDataBussiness.jobTitle}} </div>
          <div class="registration_populate registration_reviewemail" id="review-business-email">{{ formDataBussiness.emailId}}</div>
          <div class="registration_populate registration_reviewPh" id="review-business-phone">{{ formDataBussiness.phoneNo}} Ext.{{ formDataBussiness.phoneExt}} </div>
          <div class="registration_reviewlabel2 margin-T25 margin-B10">{{'reviewpage.address' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewaddress1" id="review-bussiness-address1-street">{{ formDataBussiness.line1}}&nbsp;{{ formDataBussiness.line2}} </div>
          <div class="registration_populate registration_reviewaddress2" id="review-bussiness-city-country">{{ formDataBussiness.city}}, {{ formDataBussiness.country}}</div>
          <div class="registration_populate registration_reviewaddress3" id="review-bussiness-city-post">{{ formDataBussiness.postalCode}}</div>
        </div>
      }
    </div>
    <div class="registration_reviewContainer">
      @if (formDataPaying) {
        <div class="registration_reviewpaying padding-B20">
          <div class="registration_reviewparent">
            <div class="registration_reviewlabel1">{{'reviewpage.payerdetails' | cxTranslate}}</div>
            <div class="registration_edit" id="registration_Payingedit" (click)="showPayingSection()" >{{'formLevel.edit' | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
            <div class="clearboth"></div>
          </div>
          <div class="registration_reviewlabel2 margin-B20">{{'reviewpage.contactinfo' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewname" id="review-paying-name">{{formDataPaying.firstName}}&nbsp;{{formDataPaying.lastName}}</div>
          <div class="registration_populate registration_reviewemail" id="review-paying-email">{{formDataPaying.email}}</div>
          <div class="registration_populate registration_reviewPh" id="review-paying-phone">{{formDataPaying.phone}} ext. {{formDataPaying.phoneExt}} </div>
          <div class="registration_reviewlabel2 margin-T25 margin-B20">{{'reviewpage.address' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewaddress1" id="review-paying-adrress1">{{formDataPaying.line1}}</div>
          <div class="registration_populate registration_reviewaddress2" id="review-paying-adrress2">{{formDataPaying.line2}}</div>
          <div class="registration_populate registration_reviewaddress3" id="review-paying-city-zip">{{formDataPaying.city}}, {{formDataPaying.country}} {{formDataPaying.postalCode}}</div>
        </div>
      }
      @if (formDataBilling) {
        <div class="registration_reviewBilling padding-B20">
          <div class="registration_reviewparent">
            <div class="registration_reviewlabel1">{{'reviewpage.invoicingdetails' | cxTranslate}}</div>
            <div class="registration_edit" id="registration_Billingedit" (click)="showBillingSection()" >{{'formLevel.edit' | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
            <div class="clearboth"></div>
          </div>
          <div class="registration_reviewlabel2 margin-B20">{{'reviewpage.contactinfo' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewname" id="review-billing-name">{{formDataBilling.firstName}}&nbsp;{{formDataBilling.lastName}}</div>
          <div class="registration_populate registration_reviewemail" id="review-billing-email">{{formDataBilling.email}}</div>
          <div class="registration_populate registration_reviewPh" id="review-billing-phone">{{formDataBilling.phone}} ext.{{formDataBilling.phoneExt}} </div>
          <div class="registration_reviewlabel2 margin-T25 margin-B20">{{'reviewpage.address' | cxTranslate}}</div>
          <div class="registration_populate registration_reviewaddress1" id="review-billing-address1">{{formDataBilling.line1}}</div>
          <div class="registration_populate registration_reviewaddress2" id="review-billing-address2">{{formDataBilling.line2}}</div>
          <div class="registration_populate registration_reviewaddress3" id="review-billing-city-zip">{{formDataBilling.city}}, {{formDataBilling.country}} {{formDataBilling.postalCode}}</div>
          <div class="registration_reviewlabel2 registration_reviewCheckbox margin-T25">
            <label class="registration_checkboxLabel">{{'reviewpage.alternateemail' | cxTranslate}}</label>
            <div class="clearboth"></div>
          </div>
          <div class="registration_populate registration_reviewemail" id="review-billing-account-email">{{formDataBilling.acctStmtEmail}}</div>
        </div>
      }

    </div>
    <div class="registration_reviewShipping margin-B20">
      <div class="registration_reviewparent">
        <div class="registration_reviewlabel1">{{'progresslabel.deliverylocation' | cxTranslate}}</div>
        <div class="registration_edit" id="registration_Shippingedit" (click)="showShippingSection()">{{'formLevel.edit' | cxTranslate}} <i class="fa fa-pencil-square-o" aria-hidden="true"></i></div>
        <div class="clearboth"></div>
      </div>
      <div class="registration_reviewlabel2"><span class="total_ship_location">{{ totalShippingCount }}</span> delivery locations</div>
      <div class="registration_reviewlabel3 reviewpage_DeliveryLocEmail">{{ shippingList.controls[0].value.email }}</div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding margin-T20 margin-B20 registration_button">
      <div class="registration_back active" (click)="showShippingSection()">
        <div class="global_blackarrow"></div>
        <span>{{'formLevel.Back' | cxTranslate}}</span>
        <div class="clearboth"></div>
      </div>
      <button class="registration_createAccount active" (click)="create_Account()"  type="submit">{{"reviewpage.createAccount" | cxTranslate}}</button>
      <div class="clearboth"></div>
    </div>

  </form>
</section>
<!-- added job bag codes -->

</div>



</ng-container>
<app-reg-join-acc-exit-popup></app-reg-join-acc-exit-popup>